export default {
    when() {
        return document.querySelectorAll('.card-hover').length > 0;
    },

    mounted() {
        let cards = document.querySelectorAll('.card-hover');
        document.addEventListener(
            'mouseover',
            (event) => {
                cards.forEach((card) => {
                    let withinBoundaries = event.composedPath().includes(card);

                    let cardContent = card.querySelector('.card-content');
                    let cardContentHeight = cardContent.scrollHeight;
                    let cardHide = card.querySelector('.card-hide');
                    let cardHideHeight = cardHide.scrollHeight;
                   
                    if (withinBoundaries) {
                        cardContent.style.maxHeight = cardContentHeight + 'px';
                        cardHide.style.maxHeight = '0px';
                    } else {
                        cardContent.style.maxHeight = '0px';
                        cardHide.style.maxHeight = '150px';
                    }
                });
            },
            { passive: true }
        );
    },
};
